/* assets/custom-presence.js */
(function () {
  var STORAGE_KEY = 'customProducts';
  var lastCount = -1;
  var moDom = null;

  function safeParse(json) { try { return JSON.parse(json); } catch (e) { return null; } }

  function readList() {
	// 優先: CustomList.read()。なければ localStorage 直読み
	if (window.CustomList && typeof window.CustomList.read === 'function') {
	  return window.CustomList.read() || [];
	}
	try {
	  var raw = localStorage.getItem(STORAGE_KEY);
	  var arr = safeParse(raw);
	  return Array.isArray(arr) ? arr : [];
	} catch (e) {
	  return [];
	}
  }

  function getCount() {
	var list = readList();
	return list.length;
  }

  function setRootState(count) {
	var has = count > 0;
	var root = document.documentElement;
	var body = document.body;

	// <html> に付与
	root.setAttribute('data-has-custom', has ? 'true' : 'false');
	root.setAttribute('data-custom-count', String(count));
	root.classList.toggle('has-custom-products', has);
	root.classList.toggle('no-custom-products', !has);

	// <body> にもミラー（好みで使い分け可）
	if (body) {
	  body.setAttribute('data-has-custom', has ? 'true' : 'false');
	  body.setAttribute('data-custom-count', String(count));
	  body.classList.toggle('has-custom-products', has);
	  body.classList.toggle('no-custom-products', !has);
	}

	// フローティングリンクに反映（存在すれば）
	// var float = document.getElementById('custom-floating');
	// if (float) {
	//   float.setAttribute('data-custom-count', String(count));
	//   float.setAttribute('aria-hidden', has ? 'false' : 'true'); // 0件で非表示にしやすい
	// }
  }

  function applyDirectives(count) {
	// data-show-when="custom" → カスタム有りで表示
	document.querySelectorAll('[data-show-when="custom"]').forEach(function (el) {
	  el.hidden = (count === 0);
	});
	// data-hide-when="custom" → カスタム有りで非表示
	document.querySelectorAll('[data-hide-when="custom"]').forEach(function (el) {
	  el.hidden = (count > 0);
	});
	// data-show-when-min-count="N" → N件以上で表示
	document.querySelectorAll('[data-show-when-min-count]').forEach(function (el) {
	  var need = parseInt(el.getAttribute('data-show-when-min-count') || '0', 10);
	  el.hidden = !(count >= need);
	});
	// data-hide-when-min-count="N" → N件以上で非表示
	document.querySelectorAll('[data-hide-when-min-count]').forEach(function (el) {
	  var need = parseInt(el.getAttribute('data-hide-when-min-count') || '0', 10);
	  el.hidden = (count >= need);
	});
  }

  function update() {
	var count = getCount();
	if (count === lastCount) return; // 変更なしなら何もしない
	lastCount = count;

	setRootState(count);
	applyDirectives(count);

	// 変更イベントを発火（必要ならフック可能）
	var ev = new CustomEvent('customlist:presencechange', { detail: { count: count, has: count > 0 } });
	document.dispatchEvent(ev);
  }

  function hookCustomList() {
	if (!window.CustomList || window.CustomList.__presenceHooked) return;

	// write をラップして更新を確実化（add/remove どちらでも write が呼ばれる前提）
	if (typeof window.CustomList.write === 'function') {
	  var origWrite = window.CustomList.write.bind(window.CustomList);
	  window.CustomList.write = function () {
		var ret = origWrite.apply(this, arguments);
		// 次のtickで更新（localStorage 反映後）
		setTimeout(update, 0);
		return ret;
	  };
	} else {
	  // 念のため addCurrent/remove もラップ（writeが無いテーマでも対応）
	  ['addCurrent', 'remove'].forEach(function (m) {
		if (typeof window.CustomList[m] === 'function') {
		  var orig = window.CustomList[m].bind(window.CustomList);
		  window.CustomList[m] = function () {
			var ret = orig.apply(this, arguments);
			setTimeout(update, 0);
			return ret;
		  };
		}
	  });
	}

	window.CustomList.__presenceHooked = true;
  }


  // ★追加：CustomList が後から読み込まれても hook できるようにする
  var hookTimer = null;
  
  function ensureHooked() {
	hookCustomList();
  
	// まだ CustomList が来てないなら、短時間リトライ
	if (!window.CustomList || !window.CustomList.__presenceHooked) {
	  if (!hookTimer) {
		hookTimer = setInterval(function () {
		  hookCustomList();
		  // hook できたら止める & 念のため state も更新
		  if (window.CustomList && window.CustomList.__presenceHooked) {
			clearInterval(hookTimer);
			hookTimer = null;
			update();
		  }
		}, 200);
	  }
	}
  }


  function init() {
	update();
	ensureHooked();

	// 別タブ更新に追従
	window.addEventListener('storage', function (e) {
	  if (e.key === STORAGE_KEY) update();
	});

	// 遅延挿入された要素（モーダル内など）にもディレクティブ適用
	if (!moDom) {
	  moDom = new MutationObserver(function () {
		if (lastCount >= 0) {
		  applyDirectives(lastCount);
		  // フローティングが後から出てきた場合にも反映
		//   var float = document.getElementById('custom-floating');
		//   if (float) {
		//     float.setAttribute('data-custom-count', String(lastCount));
		//     float.setAttribute('aria-hidden', lastCount > 0 ? 'false' : 'true');
		//   }
		}
		ensureHooked();
	  });
	  moDom.observe(document.documentElement, { childList: true, subtree: true });
	}
  }

  document.addEventListener('DOMContentLoaded', init);

  // 手動で再評価したい場合用
  window.CustomPresence = { update: update };
})();
